import React from 'react';
import {useCatalogs} from '../hooks/useCatalogs';
import {useLocale} from '../hooks/useLocale';
import {useSetLocale} from '../hooks/useSetLocale';
import {Select, MenuItem} from '@material-ui/core';

const LangSelector = () => {
  const catalogs = useCatalogs();
  const locale = useLocale();
  const setLocale = useSetLocale();

  return (
    <Select
      value={locale}
      onChange={(e) => {
        setLocale(e.target.value, catalogs);
      }}
      style={{color: '#fafafa'}}
    >
      {Object.keys(catalogs).map((locale) => (
        <MenuItem value={locale} key={locale}>
          {locale}
        </MenuItem>
      ))}
    </Select>
  );
};
export default LangSelector;
